import { slugify } from "../../utils/slugify";
import { getSiteUrl } from "../../utils/siteUrl";

type ShareButtonsProps = {
  title: string;
  price: string;
  slug?: string;
  url?: string;
};

export default function ShareButtons({
  title,
  price,
  slug,
  url,
}: ShareButtonsProps) {
  const resolvedSlug = slug ?? slugify(title);
  const productUrl = url ?? `${getSiteUrl()}/product/${resolvedSlug}`;

  const message = `
J’ai trouve ce joli modele chez Si’Bella

${title}
${price}

Voir le produit :
${productUrl}
  `;

  const whatsappShare = `https://wa.me/?text=${encodeURIComponent(message)}`;
  const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    productUrl
  )}`;

  const buttons = [
    {
      label: "WhatsApp",
      short: "WA",
      href: whatsappShare,
      className: "bg-[#dbf4e6] text-[#157347]",
    },
    {
      label: "Facebook",
      short: "FB",
      href: facebookShare,
      className: "bg-[#e7ecff] text-[#3752b3]",
    },
  ];

  return (
    <div className="flex items-center gap-2">
      {buttons.map((button) => (
        <button
          key={button.label}
          type="button"
          onClick={() => window.open(button.href, "_blank")}
          className={`inline-flex h-11 items-center justify-center rounded-full px-4 text-[11px] font-semibold uppercase tracking-[0.24em] transition hover:-translate-y-0.5 ${button.className}`}
          title={`Partager sur ${button.label}`}
          aria-label={`Partager sur ${button.label}`}
        >
          {button.short}
        </button>
      ))}
    </div>
  );
}
